// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"9b21fe8e","171":"601b0d49","220":"280c261d","400":"1212439f","453":"a4be4b88","842":"8205b323","940":"590dbdb7","998":"65334aa5"}[chunkId] + ".chunk.js";
};